import styled, { css, type RuleSet } from 'styled-components';
import Bullet from 'components/Bullet';
import type { BulletProps } from 'components/Bullet/Bullet';

type StatusColor = 'Green' | 'Yellow' | 'Red' | 'Black' | 'Neutral';

export type StatusProps = BulletProps & {
    color?: StatusColor;
};

export const getStatusColor = ({ color }: Pick<StatusProps, 'color'>): RuleSet<object> => {
    switch (color) {
        case 'Green':
            return css`
                ${({ theme }) => theme.ColorBackgroundSuccess}
            `;
        case 'Yellow':
            return css`
                ${({ theme }) => theme.ColorBackgroundWarning}
            `;
        case 'Red':
            return css`
                ${({ theme }) => theme.ColorBackgroundError}
            `;
        case 'Black':
            return css`
                ${({ theme }) => theme.ColorTextPrimary}
            `;
        case 'Neutral':
        default:
            return css`
                ${({ theme }) => theme.ColorBackgroundInfo}
            `;
    }
};

const StyledBullet = styled(Bullet)<Pick<StatusProps, 'color'>>`
    background: ${getStatusColor};
`;

function StatusDefault(props: StatusProps) {
    return <StyledBullet {...props} />;
}

export default StatusDefault;
